module.exports = __webpack_public_path__ + "img/pop.a111aa04.gif";